const additionalSalesDefaultState = {
  leadAssistance: {
    assistanceId: '',
    zohoId: '',
    zohoContractDetailId: '',
    customerAcceptation: '',
    axaEmailAlreadySent: false,
    delayActivation: '',
    language: null,
  },
  leadCarbonOffset: {
    offsetId: '',
    zohoId: '',
    customerAcceptation: '',
    language: null,
  },
  leadGaranka: {
    customerAgreement: '',
    offerId: '',
    buildingType: '',
    buildingAge: '',
    boilerDisposition: '',
    boilerTechnology: '',
    boilerAge: '',
    boilerBrand: '',
    zohoId: '',
    leadType: '',
  },
  leadTelecom: {
    type: '',
    callbackDate: '',
    callbackTime: '',
    zohoId: '',
    description: '',
  },
  leadTelecomLovys: {
    type: '',
    callbackDate: '',
    callbackTime: '',
    zohoId: '',
    description: '',
  },
  leadAssurance: {
    zohoId: '',
    description: '',
  },
  leadAssuranceDefault: {
    callbackDate: '',
    callbackTime: '',
    zohoId: '',
    professionalCategory: '',
    description: '',
    leadType: '',
  },
  leadMovingNextories: {
    departureCountry: '',
    departureCity: '',
    departureZipcode: '',
    earliestMovingDate: '',
    movingDescription: '',
    zohoId: '',
    errorPartnerSync: '',
  },
  leadYouStock: {
    zohoId: '',
  },
  leadEnergyProPlaceDesEnergies: {
    zohoId: '',
    commitmentEndDate: '',
    errorPartnerSync: '',
  },
  leadFloraAssuranceEthias: {
    zohoId: '',
    leadType: '',
  },
  leadFloraAssuranceLead: {
    zohoId: '',
    leadType: '',
  },
  leadYagoAssuranceHouse: {
    zohoId: '',
    leadType: '',
  },
  leadYagoAssuranceCar: {
    zohoId: '',
    leadType: '',
  },
  leadYagoAssuranceMoto: {
    zohoId: '',
    leadType: '',
  },
  leadSantevetAssurance: {
    zohoId: '',
    leadType: '',
  },
  leadEthias: {
    zohoId: '',
  },
  leadElite: {
    zohoId: '',
    leadType: '',
  },
  leadEngieBrussels: {
    zohoId: '',
    leadType: '',
  },
  leadVerisureTelecomBe: {
    zohoId: '',
    leadType: '',
    orderNumber: '',
  },
  leadBoilerEneco: {
    zohoId: '',
    leadType: '',
    orderNumber: '',
  },
  leadBoilerEngie: {
    zohoId: '',
    leadType: '',
    orderNumber: '',
  },
  leadBoilerHomeserve: {
    zohoId: '',
    leadType: '',
  },
  leadPartnership: {
    zohoId: '',
    callbackDate: '',
    callbackTime: '',
    description: '',
  },
  leadProxiserve: {
    zohoId: '',
    leadType: '',
  },
  leadWater: {
    zohoId: '',
  },
  leadMesAllocs: {
    zohoId: '',
  },
  leadGroupPurchaseTelecom: {
    zohoId: '',
  },
  leadAssistancePro: {
    zohoId: '',
  },
  leadMonConseillerPerso: {
    zohoId: '',
    offer: '',
    partnerId: '',
    errorPartnerSync: '',
    statusCodePending: true,
  },
  leadAssuranceEmprunteur: {
    zohoId: '',
    leadType: '',
  },
  leadBankPanorabanques: {
    zohoId: '',
  },
  leadBankinAssurance: {
    callbackDate: '',
    callbackTime: '',
    zohoId: '',
    type: '',
    description: '',
  },
  leadVerisure: {
    zohoId: '',
  },
  leadTucoenergie: {
    zohoId: '',
    typeCivility: '',
    typeOccupation: '',
    typeRequest: '',
    leadStatus: '',
    errorPartnerSync: '',
  },
  leadEnergygo: {
    zohoId: '',
    leadStatus: '',
    errorPartnerSync: '',
    typeRequest: '',
    typeBusiness: '',
    isMaisonOwner: '',
    acceptationRappelRenovation: '',
  },
  leadOffshoreTelecom: {
    zohoId: '',
    currentProvider: '',
  },
  leadAssurancePro: {
    zohoId: '',
    callbackDate: '',
    callbackTime: '',
  },
  leadTelecomEnergy: {
    callbackDate: '',
    callbackTime: '',
    zohoId: '',
    leadType: '',
    description: '',
  },
  leadTelecomSat: {
    callbackDate: '',
    callbackTime: '',
    zohoId: '',
    leadType: '',
    description: '',
  },
  leadVerisureTelecom: {
    zohoId: '',
    productId: '',
  },
  leadProtected: {
    zohoId: '',
    productId: '',
    invoiceFrequency: '',
    smsCode: '',
    errorPartnerSync: '',
    statusCode: null,
  },
  leadProtectedClub: {
    zohoId: '',
    productId: '',
  },
  leadAccessoriesSfr: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadAxaSmartphone: {
    zohoId: '',
    productId: '',
  },
  leadVoltalisBizdev: {
    zohoId: '',
    customerAgreement: '',
    recapAgreement: '',
  },
  leadNeat: {
    offerId: '',
    statusCode: '',
    zohoId: '',
  },
  leadCentury21: {
    zohoId: '',
  },
  leadHomyos: {
    zohoId: '',
    typeFormCreated: '',
    productId: '',
  },
  leadAssuranceEmprunteurMeilleurTaux: {
    zohoId: '',
    productId: '',
  },
  leadEddyProprietaire: {
    zohoId: '',
  },
  leadMutuelleSantiane: {
    zohoId: '',
  },
  leadYolo: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadTim: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadIren: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadFastWeb: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadProtectedIt: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadEdison: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadEnel: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadSorgenia: {
    zohoId: '',
    product: '',
    productId: '',
    saleId: '',
  },
  leadEmoovz: {
    zohoId: '',
    formCreated: '',
  },
}

export default additionalSalesDefaultState
